const APP_ENV_VALUES = ['local', 'production'] as const;

type AppEnv = (typeof APP_ENV_VALUES)[number];

function normalizeAppEnv(value: string | null | undefined): AppEnv | null {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  if (normalized === 'prod' || normalized === 'preview') {
    return 'production';
  }

  return APP_ENV_VALUES.includes(normalized as AppEnv)
    ? (normalized as AppEnv)
    : null;
}

export function getAppEnv(): AppEnv {
  const appEnv = normalizeAppEnv(process.env.APP_ENV);
  if (appEnv) {
    return appEnv;
  }

  return process.env.NODE_ENV === 'production' ? 'production' : 'local';
}

export function isLocalAppEnv() {
  return getAppEnv() === 'local';
}

export function isProductionAppEnv() {
  return getAppEnv() === 'production';
}

export function isNextProductionBuildPhase() {
  return process.env.NEXT_PHASE === 'phase-production-build';
}
